import type { RouteLocationNormalized } from "vue-router";
/**
 * Authorize user
 */
// eslint-disable-next-line no-restricted-exports
export default defineNuxtRouteMiddleware(
    async (to: RouteLocationNormalized) => {
        const { slug } = storeToRefs(useSlugStore());

        if (!slug.value) {
            return showError({
                statusCode: 404,
            });
        }

        const { isAuthorised } = useAuthorisationChecker();

        const isAuthorisedForPage = isAuthorised(to.meta);

        if (!isAuthorisedForPage) {
            return showError({
                statusCode: 404,
            });
        }

        const tokenStore = useTokenStore();
        const { isLoggedIn } = storeToRefs(tokenStore);
        const { attemptNavigateToRedirect } = tokenStore;

        if (isLoggedIn.value && to.name === "slug-login") {
            return await attemptNavigateToRedirect();
        }
    },
);
